<style lang="scss" scoped>
p {
  background-color: whitesmoke;
  border-radius: 2px;
  margin: 2px;
  padding: 5px;
}
</style>
<template lang="pug">
div
  .field(v-if="printOut")
    strong {{ question }}
    p {{ value === true ? 'Yes' : 'No' }}
  .field(v-else)
    label.label {{ question }}
    .frow.row-start.no-wrap.guide-question
      label
        input(
          type="radio",
          class="reset",
          :name="name",
          :value="true"
          v-model="value"
          @input="$emit('input', true)"
        )
        | Yes
      label
        input(
          type="radio",
          class="reset",
          :name="name",
          :value="false"
          v-model="value"
          @input="$emit('input', false)"
        )
        | No
</template>
<script>
export default {
  name: "form-section",
  props: {
    name: {
      type: String
    },
    printOut: {
      type: Boolean,
      default: false
    },
    question: {
      type: String,
      default: "Title"
    },
    value: {
      type: Boolean
    }
  }
};
</script>
